import(/* webpackMode: "eager" */ "/vercel/path1/app/page.tsx");
